import fetch from '@/utils/fetch'

export function getDshProblemList () {
  return fetch({
    url: '/getDshProblemList',
    params: {
    },
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/api_prepareProblemList.js